import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../../core/actions/expertise.actions';
import * as fromExpertise from '../../core/reducers/expertise.reducer';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { map, startWith, delay } from 'rxjs/operators';

@Component({
  selector: 'app-expertise-view',
  templateUrl: './expertise-view.component.html',
  styleUrls: ['./expertise-view.component.scss']
})
export class ExpertiseViewComponent implements OnInit {

  @Input() expertise: any;
  @Input() full: boolean = true;

  constructor(private store: Store<any>, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  	
  }

}
